/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StornextManagerAttributes
 */
export interface StornextManagerAttributes {
    /**
     * 
     * @type {string}
     * @memberof StornextManagerAttributes
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof StornextManagerAttributes
     */
    policyClass: string;
    /**
     * 
     * @type {number}
     * @memberof StornextManagerAttributes
     */
    existingCopies: number;
    /**
     * 
     * @type {number}
     * @memberof StornextManagerAttributes
     */
    targetCopies: number;
}

export function StornextManagerAttributesFromJSON(json: any): StornextManagerAttributes {
    return StornextManagerAttributesFromJSONTyped(json, false);
}

export function StornextManagerAttributesFromJSONTyped(json: any, ignoreDiscriminator: boolean): StornextManagerAttributes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'location': json['location'],
        'policyClass': json['policy_class'],
        'existingCopies': json['existing_copies'],
        'targetCopies': json['target_copies'],
    };
}

export function StornextManagerAttributesToJSON(value?: StornextManagerAttributes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'location': value.location,
        'policy_class': value.policyClass,
        'existing_copies': value.existingCopies,
        'target_copies': value.targetCopies,
    };
}


